import React, { useState } from "react";
import style from "./style.module.scss"
import { Github } from "../../services/github/service";
import UserListItem from "../../components/users/userListItem/index"
import {useNavigate} from 'react-router-dom'


const Search = () => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const [users, setUsers] = useState([]);


    const getSkeletons = () => {
        let skeletons = [];
        for (let i = 0; i < 10; i++) {
            skeletons.push(<UserListItem loading={true} key={i} />)
        }
        return skeletons;
    }


    const searchUsers = async (query) => {
        setLoading(true);
        const response = await Github.searchUsers(query);
        setUsers(response.items);
        setLoading(false);
        return response.data;
    }

    const handleUserSelect = (user) => {
        console.log(user);
        navigate(`/users/${user.login}`)
        setShowModal(false);
    }

    const handleUserSearch = (event) => {
        let query = event.target.value;
        if(query.length)
        {
            setShowModal(true);
           debounce(searchUsers, 500)(query)
        }else{
            setShowModal(false);
        }
    }
    let timer;

    function debounce(func, timeout = 300){
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
      }
    
    return (
        <div className={style.search}>
            <span class="material-symbols-outlined">
search
</span>
       <input onKeyUp={handleUserSearch} type="text" placeholder="Search users..."   />
       {
        showModal ? <div className={style.searchResults}>
        {loading && <div>{getSkeletons()}</div>}
        {users.map(user => {
          return<UserListItem  onSelect={handleUserSelect} user={user} />
        })}
 </div>:''
       }
       
        </div>
    );
}

export default Search;